import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderService } from 'src/app/services/order/order.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { TripService } from 'src/app/services/trip/trip.service';
import { TransporterService } from 'src/app/services/transporter/transporter.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { NgxDateRangePickerOptions } from '../../../ngx-daterangepicker';
import { TokenStorage } from 'src/app/auth/token.storage';
import { ExcelgeneratorService } from 'src/app/services/excelgenerator/excelgenerator.service';

@Component({
  selector: 'app-summary-report',
  templateUrl: './summary-report.component.html',
  styleUrls: ['./summary-report.component.scss']
})
export class SummaryReportComponent implements OnInit {
  columnsOrderReport = [
    'warehouse',
    'totalOrdersReceived',
    'sameStoreOrder',
    'totalDelivery',
    'scheduledForPickup',
    'inTransit',
    'completed',
    'totalFailed',
    'serialNoScanned'
  ];
  columnUploadReport = [
    'warehouse',
    'unplanned',
    'inplanning',
    'scheduled',
  ];

  columnsTripReport = [
    'warehouse',
    'totalTrip',
    'inTransit',
    'completed',
    'totalTripTime',
    'totalTripDistance',
    'totalTripCost'
  ];

  columnsTransReport = [
    'transporter',
    'warehouse',
    'contactPerson',
    'contactMobile',
    'totalTripTime',
    'totalTripDistance',
    'totalTripCost'
  ];

  columnsSmsReport = [
    'totalOrders',
    'smsDeliveredCount'
  ];

  columnsFailedReason = [
    'warehouse',
    'totalFailed',
    'customerNotAvailable',
    'dent',
    'customerDontWantDelivery',
    'exchangeNotDismantles',
    'wrongDeliveryAddress',
    'wrongOrder',
    'modelChange',
    'orderCancelled',
    'officeClosed',
    'other'
  ]

  fromDate: any;
  toDate: any;
  isOrderLoading = true;
  isTripLoading = true;
  isTransLoading = true;
  isSmsLoading = true;


  prevFromDate: any;
  prevTodate: any;
  daterRangevalue: any;

  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  orderSummaryArray = new MatTableDataSource();
  tripSummaryArray = new MatTableDataSource();
  transporterSummaryArray = new MatTableDataSource();
  smsSummaryArray = new MatTableDataSource();
  options: NgxDateRangePickerOptions;
  totalTransRecords = 0;
  totalOrderRecords = 0;
  totalTripRecords = 0;
  totalSmsRecords = 0;
  isDateFiltered: boolean = false;
  isBajaj: boolean = false;
  excelRecords = [];

  @ViewChild('orderPaginator') orderPaginator: MatPaginator;
  @ViewChild('tripPaginator') tripPaginator: MatPaginator;
  @ViewChild('transporterPaginator') transporterPaginator: MatPaginator;
  @ViewChild('smssPaginator') smssPaginator: MatPaginator;


  constructor(private orderService: OrderService,
    public datePipe: DatePipe,
    private tripService: TripService,
    private transporterService: TransporterService,
    private token: TokenStorage,
    private excelService: ExcelgeneratorService) { }

  ngOnInit() {
    if (this.token.getTenant() == 'bajaj-reta-test' || this.token.getTenant() == 'bajaj-reta-prod') {
      this.isBajaj = true;
    }
    this.createInitialFilter();
  }

  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.orderFilter();
    this.tripFilter();
    if(!this.isBajaj){
    this.transporterFilter();
    this.smsFilter();
    }
  }

  orderFilter() {
    this.isOrderLoading = true;
    this.orderSummaryArray.data = [];
    this.totalOrderRecords = 0;
    this.orderService.getOrderSummaryReport(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
      this.isOrderLoading = false;
      console.log("Orders Summarry", orders);
      orders = orders.filter(order=>(order.totalOrdersReceived!=0))
      this.totalOrderRecords = orders.length;
      this.orderSummaryArray.data = orders;
      this.orderSummaryArray.paginator = this.orderPaginator;
    }, Error => {
      this.isOrderLoading = false;
    })
  }

  tripFilter() {
    this.isTripLoading = true;
    this.totalTripRecords = 0;
    this.tripSummaryArray.data = [];
    this.tripService.getTripSummaryReport(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(tripSummary => {
      this.isTripLoading = false;
      console.log("Trip Summarry", tripSummary);
      this.totalTripRecords = tripSummary.length;
      this.tripSummaryArray.data = tripSummary;
      this.tripSummaryArray.paginator = this.tripPaginator;
    }, Error => {
      this.isTripLoading = false;
    })
  }
  transporterFilter() {
    this.isTransLoading = true;
    this.totalTransRecords = 0;
    this.transporterSummaryArray = null;
    this.transporterService.getTransporterSummaryReport(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(transSummary => {
      this.isTransLoading = false;
      console.log("Transporter Summarry", transSummary);
      this.totalTransRecords = transSummary.length;
      this.transporterSummaryArray = transSummary;
    }, Error => {
      this.isTransLoading = false;
    }
    )
  }

  smsFilter() {
    this.isSmsLoading = true;
    this.smsSummaryArray = null;
    this.totalSmsRecords = 0;
    this.orderService.getSmsReport(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(smsSummary => {
      this.isSmsLoading = false;
      this.smsSummaryArray = smsSummary;
      this.totalSmsRecords = smsSummary.length;
    }, Error => {
      this.isSmsLoading = false;
    })
  }

  sortByDate() {
    if (!this.daterRangevalue) {
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.orderFilter();
      this.tripFilter();
      if(!this.isBajaj){
      this.transporterFilter();
      this.smsFilter();
      }
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
    }

    else if (this.daterRangevalue) {
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
        this.isDateFiltered = true;
        this.ngUnsubscribe.next();
        this.orderFilter();
        this.tripFilter();
        if(!this.isBajaj){
        this.transporterFilter();
        this.smsFilter();
        }
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
      }
    }
  }

  clearAllFilter() {
    // this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.isDateFiltered = false;
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'ordersReport');
  }

  dataForExcel() {
    let ordersArray;
    ordersArray = this.orderSummaryArray.data;
    this.excelRecords = [];
    let count = 0;
    ordersArray.forEach(order => {

    if(order && (order.totalOrdersReceived >0 || order.totalOrdersReceived != null)){
    
          this.excelRecords.push({
              'Store': order.branchName+"["+order.branchArea+"]" || '0',
              'Received From TPOS': order.totalOrdersReceived || '0',
              'Same Store Initial': order.sameStoreOrders || '0',
              'Same Store Processed': order.totalOrders || '0',
              'In Transit': order.intransitOrders || '0',
              'Completed': order.completedOrders || '0',
              'Failed': order.failedOrders || '0',
              'Serial No Scanned': order.serialnoScanned || '0',
              'WH/OtherStores Initial': order.initialWHAndOtherStores || '0' , 
            });  
       
          if (order.ordersAssignedBranchStats && order.ordersAssignedBranchStats.length > 0) {
            let totalStoreCount = 0;
            order.ordersAssignedBranchStats.forEach(branch => {
              if (branch.branchType == 'Warehouse') {
                Object.assign(this.excelRecords[count],{[branch.branch.toString()] : branch.numberOfOrdersAssigned || '0'});
 
              }
              else if(branch.branchType == 'Store'){
              totalStoreCount = totalStoreCount + branch.numberOfOrdersAssigned
              }
            });
            Object.assign(this.excelRecords[count],{'Other Stores Processed' : totalStoreCount || '0'});
          }
          count+=1;
        }
    });
  }
}
